export function UndoIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        fill="currentColor"
        d="M3.28.901C4.761.161 5.502-.21 6.044.124c.443.274.52.88.535 1.998H7.76c.823 0 1.507-.001 2.061.049.568.051 1.098.164 1.59.447a3.7 3.7 0 0 1 1.353 1.354c.283.49.395 1.02.447 1.589.05.554.049 1.239.049 2.061 0 .823.001 1.507-.049 2.062-.052.568-.164 1.098-.447 1.589a3.7 3.7 0 0 1-1.354 1.353c-.49.283-1.02.396-1.589.447-.554.05-1.238.05-2.061.05h-4.5a1 1 0 0 1 0-2h4.5c.86 0 1.437-.002 1.88-.042.43-.039.635-.108.77-.186a1.7 1.7 0 0 0 .622-.622c.079-.136.148-.34.187-.77.04-.443.04-1.021.04-1.88 0-.86 0-1.438-.04-1.882-.04-.429-.108-.634-.187-.77a1.7 1.7 0 0 0-.622-.621c-.136-.079-.34-.148-.77-.187-.443-.04-1.02-.04-1.88-.04H6.582c-.007 1.28-.062 1.953-.537 2.247-.542.335-1.283-.036-2.766-.777l-.603-.3C.892 4.4 0 3.952 0 3.246s.892-1.152 2.676-2.044z"
      />
    </svg>
  );
}
